var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2806 18.2193C19.3503 18.289 19.4056 18.3717 19.4433 18.4628C19.481 18.5538 19.5004 18.6514 19.5004 18.7499C19.5004 18.8485 19.481 18.9461 19.4433 19.0371C19.4056 19.1281 19.3503 19.2109 19.2806 19.2806C19.2109 19.3502 19.1282 19.4055 19.0372 19.4432C18.9461 19.4809 18.8486 19.5003 18.75 19.5003C18.6515 19.5003 18.5539 19.4809 18.4628 19.4432C18.3718 19.4055 18.2891 19.3502 18.2194 19.2806L12 13.0602L5.78063 19.2806C5.6399 19.4213 5.44903 19.5003 5.25 19.5003C5.05098 19.5003 4.86011 19.4213 4.71938 19.2806C4.57865 19.1398 4.49959 18.949 4.49959 18.7499C4.49959 18.5509 4.57865 18.36 4.71938 18.2193L10.9397 11.9999L4.71938 5.78055C4.57865 5.63982 4.49959 5.44895 4.49959 5.24993C4.49959 5.05091 4.57865 4.86003 4.71938 4.7193C4.86011 4.57857 5.05098 4.49951 5.25 4.49951C5.44903 4.49951 5.6399 4.57857 5.78063 4.7193L12 10.9396L18.2194 4.7193C18.3601 4.57857 18.551 4.49951 18.75 4.49951C18.949 4.49951 19.1399 4.57857 19.2806 4.7193C19.4214 4.86003 19.5004 5.05091 19.5004 5.24993C19.5004 5.44895 19.4214 5.63982 19.2806 5.78055L13.0603 11.9999L19.2806 18.2193Z",
    fill: "#0D0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.9baffadd78430b0cd9bbb6910a731f67.svg";
export { ForwardRef as ReactComponent };